import Input from "decorator-form/dist/decorators/input/Input";
import { Entity } from "typegraph";
import Field from "typegraph/dist/decorators/field/Field";
import InputType from "common/form/InputType";
import DropdownSelect from "../../../common/form/widgets/common/DropdownSelect";
import Forum from "./Forum";

const DigestOptions = DropdownSelect.registerWithOptions([
	{
		value: "none",
		label: "None"
	},
	{
		value: "immediate",
		label: "Immediately"
	},
	{
		value: "daily",
		label: "Daily"
	},
	{
		value: "weekly",
		label: "Weekly"
	}
]);

@Entity({one: "forumSubscription", many: "forumSubscriptionsUser", create: "forumSubscriptionCreate", update: "forumSubscriptionUpdate",delete: "forumSubscriptionDelete"})
export class ForumSubscription {

	@Field()
	id: number;

	@Field()
	@Input({type: InputType.CHECKBOX, title: "Instant Notification"})
	instant: boolean = true;

	user: number;

	forum: number;

	// temporary untill the graphql api supports the same type for both mutations and queries
	@Field({aliasFor: "forum", entity: Forum})
	forumEntity: Forum;

	@Field()
	@Input({type: InputType.CHECKBOX, title: "Recieve Emails"})
	emailNotification: boolean = true;

	@Field()
	@Input({type: DigestOptions, title: "Send a notification summary email", required: true})
	digest: String;
}



// WEBPACK FOOTER //
// ./src/panels/forum/entity/ForumSubscription.ts